module.exports = __webpack_public_path__ + "assets/img/tx15b_1.2a5b968d.jpg";